import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRequestQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={14}
    fill="none"
    viewBox="0 0 10 14"
    {...props}
  >
    <path
      fill="#3752B3"
      d="M4.4 11v.5q0 .133.083.217a.3.3 0 0 0 .217.083h.6a.3.3 0 0 0 .217-.083.3.3 0 0 0 .083-.217V11h.2a.77.77 0 0 0 .57-.23.77.77 0 0 0 .23-.57V9a.77.77 0 0 0-.23-.57.77.77 0 0 0-.57-.23H4.2V7h2a.39.39 0 0 0 .285-.114.38.38 0 0 0 .115-.284.4.4 0 0 0-.115-.285A.38.38 0 0 0 6.2 6.2h-.6v-.5a.3.3 0 0 0-.083-.217A.3.3 0 0 0 5.3 5.4h-.6a.3.3 0 0 0-.217.083.3.3 0 0 0-.083.217v.5h-.2a.77.77 0 0 0-.57.23.77.77 0 0 0-.23.57v1.2q0 .34.23.57T4.2 9h1.6v1.2h-2a.39.39 0 0 0-.285.114.38.38 0 0 0-.115.284q0 .168.115.285A.38.38 0 0 0 3.8 11zm-3.005 2.4q-.495 0-.845-.353A1.16 1.16 0 0 1 .2 12.2V1.8q0-.495.353-.848Q.905.6 1.4.6h5.2l3.2 3.2v8.4q0 .495-.353.848a1.16 1.16 0 0 1-.848.352zm.005-1.2h7.2V4.6H6.4a.58.58 0 0 1-.427-.173A.58.58 0 0 1 5.8 4V1.8H1.4z"
    />
  </svg>
);
export default SvgRequestQuote;
